import { ref, shallowRef } from 'vue';
import { analyzes } from '../../../src/utils.mjs';

const useComposable = (emits) => {
  const refs = {
    end: ref(),
    date: ref(/* @__PURE__ */ new Date()),
    start: ref(),
    months: shallowRef([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11])
  };
  const methods = {
    //* 更新函数
    date: (data) => emits("update", data),
    //* 初始化函数
    init: (data) => {
      refs.end.value = analyzes.date(data.end);
      refs.date.value = data.date;
      refs.start.value = analyzes.date(data.start);
    },
    //* 状态更新
    update: (date) => refs.date.value = date,
    //* 切换函数
    change: (number) => {
      emits("update", { month: number });
      emits("switchover", "auto");
    },
    //* 检测月份状态
    get_month_status: (month) => {
      var _a, _b, _c, _d;
      const result = [];
      const currentYear = refs.date.value.getFullYear();
      const startMonth = (_a = refs.start.value) == null ? void 0 : _a.getMonth();
      const startYear = (_b = refs.start.value) == null ? void 0 : _b.getFullYear();
      const endMonth = (_c = refs.end.value) == null ? void 0 : _c.getMonth();
      const endYear = (_d = refs.end.value) == null ? void 0 : _d.getFullYear();
      if (currentYear == startYear && startMonth == month || currentYear == endYear && endMonth == month) result.push("ui-active");
      else if (startMonth != void 0 && startYear != void 0 && endMonth != void 0 && endYear != void 0) {
        if (currentYear < endYear && currentYear > startYear) result.push("ui-contain-status");
        else if (currentYear == startYear && month >= startMonth) result.push("ui-contain-status");
        else if (currentYear == endYear && month <= endMonth) {
          result.push("ui-contain-status");
        }
      }
      return result.join(" ");
    }
  };
  return { refs, methods };
};

export { useComposable };
//# sourceMappingURL=composable.mjs.map
